
angular.module('authentication_processes')

    .controller("authenticationProcessesListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state', 'logService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state, logService) {

            $scope.allowWrite = true;

            $rootScope.title = $filter('translate')('authentication_processes.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('authentication_processes.title') }
            ];

        // $scope.allowWrite = LoginService.permissionExist("AUTHENTICATION_SERVICES_WRITE");

        $scope.gridOptions= {
            pdfTitle: "Servicios",
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'Name', displayName: $filter('translate')('general.name'), enableFiltering: true, enableHiding: false },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.button_edit'), action: 'ui-sref="authentication_processes.edit({id:row.entity.id})"; ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"',  cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                },
            ],

            getData: function (options) {
                return Restangular.all('AuthenticationProcesses').getList(options).then(function (results) {
                    return results;
                })
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("authentication_processes.edit", { id: rowEntity.id });
        };

        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('events_types.button_delete'),
                message: $filter('translate')('authentication_processes.delete_message'),
                onAccept: function () {
                    Restangular.one('AuthenticationProcesses', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('authentication_processes.deleted_success'));
                        $scope.gridOptionsAuthenticationServices.gridApi.core.raise.itemDeleted($scope);

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });


        }
    }])